export default __webpack_public_path__ + "static/media/gel-sweet-florale-1.391d8085.jpg";